export default {
    namespaced: true,

    state: {
        authUser: null,
        conversation: null,
    },
    actions: {
        setAuthUser({ commit }, user) {
            commit('SET_AUTH_USER', user);
        },

        switchConversation({ commit }, conversation) {
            commit('SET_CONVERSATION', conversation);
        },
    },
    mutations: {
        SET_AUTH_USER(state, user) {
            state.authUser = user;
        },
        SET_CONVERSATION(state, conversation) {
            state.conversation = conversation;
        },
    },
};
